import { render, staticRenderFns } from "./DHFData.vue?vue&type=template&id=34be60ec&scoped=true&"
import script from "./DHFData.vue?vue&type=script&lang=js&"
export * from "./DHFData.vue?vue&type=script&lang=js&"
import style0 from "./DHFData.vue?vue&type=style&index=0&id=34be60ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34be60ec",
  null
  
)

export default component.exports